import React from 'react'
import { Achievement } from './Achievement'
import { useStateValue } from '@State'
import { history } from './App'

export const AchievementGroup = ({ title, achievements }) => {
  const [currentState] = useStateValue()
  let acmtType = title === 'Certificates' ? 'certificate' : 'badge'

  return (
    <div className="card-myed">
      <div className="d-flex justify-content-between">
        <h3 className="w-75 m-0">{title}</h3>
        <button
          className="btn btn-myed btn-default btn-default-myed btn-sm-myed"
          onClick={() =>
            history.push(
              `/instructor/achievements/${currentState.coursenum}/-/${acmtType}/edit`
            )
          }
        >
          <i className="fa-regular fa-plus mr-2" />
          Add
        </button>
      </div>
      <div className="mt-3">
        {achievements.map((acmt, i) => (
          <div key={i} className="mt-2" style={{ listStyleType: 'none' }}>
            <Achievement
              itemId={acmt.id}
              name={acmt.template.name}
              acmtType={acmt.template.type}
              requiredScores={acmt.requiredScores}
            />
          </div>
        ))}
      </div>
    </div>
  )
}
